export default {
  assignedLoads: 'Assigned loads',
  currentLoads: 'Current loads',
  endedLoads: 'Ended loads',
  origin: 'Origin',
  destination: 'Destination',
  multiDestination: 'Multi-destination',
  loadDetail: 'Load detail',
  loading: 'Loading',
  discharge: 'Discharge',
  received: 'Received',
  delivered: 'Delivered',
  pendingDelivery: 'Pending delivery',
  successfulDelivery: 'Successful delivery',
  failedDelivery: 'Failed delivery',
  showResolvedDestinations: 'Show resolved destinations',
  cityAndProvince: 'City / province',
  destination1: 'first destination',
  destination2: 'second destination',
  destination3: 'third destination',
  destination4: 'fourth destination',
  destination5: 'fifth destination',
  destination6: 'sixth destination',
  destination7: 'seventh destination',
  destination8: 'eighth destination',
  destination9: 'ninth destination',
  destination10: 'tenth destination',
  finalDestination: 'Final destination',
  stepActions: {
    reachOrigin: 'Reached to origin',
    loading: 'Loading complete',
    received: 'Received',
    reachMiddlePoint: 'Reached to {middlePoint}',
    reachDestination: 'Reached to destination',
    reachDestination1: 'Reached to first destination',
    reachDestination2: 'Reached to second destination',
    reachDestination3: 'Reached to third destination',
    reachDestination4: 'Reached to fourth destination',
    reachDestination5: 'Reached to fifth destination',
    reachDestination6: 'Reached to sixth destination',
    reachDestination7: 'Reached to seventh destination',
    reachDestination8: 'Reached to eighth destination',
    reachDestination9: 'Reached to ninth destination',
    reachDestination10: 'Reached to tenth destination',
    reachFinalDestination: 'Reach to final destination',
    delivered: 'Delivery complete',
    discharge: 'Discharge complete'
  },
  carType: 'Car type',
  loaderType: 'Loader type',
  numberOfWorkers: 'Number of workers',
  trajectory: 'Trajectory',
  noAllocation: 'No allocation',
  generalInfo: 'General info',
  loadTime: 'Load time',
  dischargeTime: 'Discharge time',
  estimatedTimeFromOriginToDestination:
    'Estimated time from origin to destination',
  distanceFromOriginToDestination: 'Distance from origin to destination',
  justBillOfLadingInfo: 'Just bill of ladinf info',
  driverOfferAmount: 'Driver offer amount',
  driverName: 'Driver name',
  driverLastName: 'Driver last name',
  driverNationalId: 'Driver national ID',
  smartFleetCode: 'Smart fleet code',
  plate: 'Plate',
  originAndDestinationInfo: 'Origin and destination info',
  deliverer: 'Deliverer',
  transferee: 'Transferee',
  floor: 'Floor',
  unit: 'Unit',
  distanceFromDoorToCar: 'Distance from door to car',
  loadType: 'Load type',
  loadSpecifications: 'Load specifications',
  package: 'Package',
  packageType: 'Package type',
  weight: 'Weight',
  loadMonetaryValue: 'Load monetary value',
  monetaryValue: 'Monetary value',
  totalOrderAmount: 'Total order amount',
  acceptOffer: 'Accept offer',
  pricing: 'Pricing',
  deliveryCode: 'Delivery code',
  dischargeDescription:
    'To discharge load, enter delivery code that sent to customer',
  sendDeliveryCodeToCustomer: 'Send delivery code to customer',
  showMiddlePoints: 'Show middle points',
  hideMiddlePoints: 'Hide middle points',
  yourOffer: 'your offer',
  totalAmount: 'Total amount',
  loadId: 'Load id',
  extractPoint: 'Extract point',
  dischargePoint: 'Discharge location',
  dischargeStartTime: 'Discharge start time',
  dischargeEndTime: 'Discharge end time',
  contractType: 'contact type',
  shift: 'Shift',
  reason: 'Reason',
  unsuccessfulDestinations: 'Unsuccessful destination',
  destinationOrderId: 'Order number: {orderId}',
  customerNameDestination: 'Customer name: {name}',
  customerPhoneNumberDestination: 'Customer phone number: {mobile}',
  failedReasonDestination: 'Failed delivery reason: {reason}',
  addressDestination: 'Address: {address}'
}
